import styled from 'styled-components';

import ZIndexLayers from '../../../services/ZIndexLayers';
import { ThemeProp } from '../../../theme/Themes';

export const FilterFooterMobile = styled.div`
  position: relative;
  display: flex;
  bottom: 0;
  right: 0;
  left: 0;
  height: auto;
  gap: 1rem;
  padding: 1.5rem;
  justify-content: space-between;
  border-top: solid 1px ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  z-index: ${ZIndexLayers.actions};
`;
